export const calcBundleCost = (bundle) => {
  const total = bundle.sections.reduce((acc, cur) => {
    let sectionUplift = cur.products.reduce((acc, cur) => {
      if (cur.upliftPrice) {
        return acc += cur.upliftPrice * cur.product.quantity;
      } else return acc;
    }, 0);
    return acc += sectionUplift;
  }, bundle.basePrice);
  return total;
};

export const dereff = (item) => {
  if (Array.isArray(item)) {
    return [...item.map(el => dereff(el))];
  } else if (typeof item === 'object' && item !== null) {
    let newObj = {};
    Object.keys(item).forEach(key => {
      newObj[key] = dereff(item[key]);
    });
    return { ...newObj };
  } else {
    return item;
  }
};

export const removeOptions = (bundle) => {
  let newBundle = dereff(bundle);
  if (newBundle?.sections.length)
    newBundle.sections.forEach(el => {
      el.products = [];
    });
  return newBundle;
};

export const findProduct = (fn, product, customisedBundle, sectionId, maxItems) => {
  const newCustomBundle = dereff(customisedBundle);
  const section = newCustomBundle.sections.find(el => el.id === sectionId);
  const exists = section.products.findIndex(el => `${getBaseName(el)}${el.product.name}` === `${getBaseName(product)}${product.product.name}`);
  const itemNumber = GetItemNumber(section);

  return fn(product, newCustomBundle, exists, section, itemNumber, maxItems);
};

export const andAdd = (product, newCustomBundle, exists, section, itemNumber, maxItems) => {
  const qty = section.quantityOnSelection || 1;
  if (exists > -1) {
    return newCustomBundle;
  } else if (exists === -1 && itemNumber === maxItems) {
    section.products.shift();
    section.products.push(addQuantity(product, qty));
  } else if (exists === -1 && itemNumber < maxItems) {
    section.products.push(addQuantity(product, qty));
  }
  return newCustomBundle;
};

export const andIncrease = (product, newCustomBundle, exists, section, itemNumber, maxItems) => {
  const step = section.quantityOnSelection || 1;
  if (itemNumber === maxItems) return newCustomBundle;
  if (exists > -1) {
    section.products[exists].product.quantity += step;
  } else if (exists === -1) {
    section.products.push(addQuantity(product, step));
  }
  return newCustomBundle;
};

export const andDecrease = (_, newCustomBundle, exists, section, itemNumber) => {
  const step = section.quantityOnSelection || 1;
  const existingProduct = section.products[exists].product;
  if (itemNumber === 0 || exists === -1) return newCustomBundle;
  if (existingProduct.quantity > step) {
    existingProduct.quantity -= step;
  } else {
    section.products.splice(exists, 1);
  }
  return newCustomBundle;
};

export const removeDisabledItem = (itemIds, customisedBundle) => {
  const newCustomBundle = dereff(customisedBundle);
  newCustomBundle.sections.forEach(s => {
    const idx = s.products.findIndex(p => itemIds.includes(p.product.id));
    if (idx >= 0) {
      s.products.splice(idx, 1);
    }
  });
  return newCustomBundle;
};

export const addQuantity = (product, qty = 1) => {
  const subProduct = fixSubProductQuantity(product.product, qty);
  return { ...product, product: subProduct };
};

export const fixSubProductQuantity = (product, qty = 1) => {
  if (product.isGroup) {
    return { ...product, subProducts: product.subProducts.map(p => fixSubProductQuantity(p, qty)) };
  }
  if (!product.isGroup && (!product.quantity || product.quantity === 0)) {
    return { ...product, subProducts: product.subProducts.map(p => fixSubProductQuantity(p, qty)), quantity: qty };
  }
};

export const GetItemNumber = (section) => {
  return section.products.reduce((acc, cur) => {
    return acc + cur.product.quantity;
  }, 0);
};

export const filterAvailableBundles = (bundles, categoryName) => {
  return bundles?.filter(b => b.category && b.category?.toLowerCase() === categoryName?.toLowerCase()) ?? [];
};

export const getBaseName = (option) => {
  if (option?.product) {
    const portion = option.product.subProducts[0].subProducts[0];
    if (portion?.id === '26' || portion?.id === '27') {
      return portion.name;
    } else return false;
  }
};

export const bundleDisplayIdxComparer = (a, b) => {
  if (a.displayIdx < b.displayIdx) {
    return -1;
  }
  if (a.displayIdx > b.displayIdx) {
    return 1;
  }
  return 0;
};

export const isBundleInStock = (bundle) => {
  return bundle.sections.every(s => s.products.some(p => !p.product.outOfStock));
};